import { useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import "./index.css";
import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "../../config";

import { login } from "../../redux/slices/auth";
import Base from "components/ConfiguratorApp/Base";
import useSettings from "components/ConfiguratorApp/hooks/useSettings";

const Login = (props) => {
  const settings = useSettings();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    //If url contains a query string with a customer name, set the customer name in the settings
    const urlParams = new URLSearchParams(window.location.search);
    let customerName = urlParams.get("customerName")?.toLowerCase();

    if (window.location.host.split(".")[0].indexOf("mlp")) {
      customerName = "mlp";
    }

    if (customerName && settings.DEFAULTS[customerName]) {
      settings.setSettings({
        ...settings.DEFAULTS[customerName],
      });
    } else if (customerName) {
      //If the customer name is not valid, redirect to the login page
      alert(customerName + " is not onboarded yet.");
      settings.setSettings({
        ...settings.DEFAULTS["server-builds"],
      });
      history.push("/");
    } else {
      settings.setSettings({
        ...settings.DEFAULTS["server-builds"],
      });
    }
  }, []);

  useEffect(() => {
    if (user._id) {
      if (user.userGroup.name === "configurator") {
        if (user.customer) {
          let customerName = user.customer.name;
          if (settings.DEFAULTS[customerName]) {
            settings.setSettings({
              ...settings.DEFAULTS[customerName],
            });
          }
        }
        history.push("/configurable-products");
      } else {
        settings.setSettings({
          ...settings.DEFAULTS["server-builds"],
        });
        history.push("/admin/products");
      }
    }
  }, [user, history]);

  const submit = async (values, { resetForm }) => {
    console.log("values: ", values);
    try {
      const response = await axios.post(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/users/login`,
        values
      );
      console.log("response: ", response);
      if (response.status === 200) {
        dispatch(
          login({
            user: response.data.user,
          })
        );
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email address").required("Required"),
    password: Yup.string().min(1, "Too Short!").required("Required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validateOnMount: true,
    validationSchema: LoginSchema,
    onSubmit: submit,
  });

  const { email, password } = formik.values;

  return (
    <Base hideLinks={true}>
      <Container style={{ minHeight: "75vh" }}>
        <Row>
          <Col xs={{ span: 10, offset: 1 }} lg={{ span: 6, offset: 3 }}>
            <div className="page">
              <div style={{ textAlign: "center" }}>
                <img src={settings.customerLogo} className="logo" />
                <br />
                <br />
                <h1>Login</h1>
              </div>

              <Form onSubmit={formik.handleSubmit}>
                <Form.Group controlId="email" size="lg">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={email}
                    onChange={formik.handleChange}
                    isValid={formik.touched.email && !formik.errors.email}
                  />
                </Form.Group>
                <Form.Group controlId="password" size="lg">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={password}
                    onChange={formik.handleChange}
                    isValid={formik.touched.password && !formik.errors.password}
                  />
                </Form.Group>
                <Button block size="lg" type="submit">
                  Login
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </Base>
  );
};

export default Login;
